export const POST_MESSAGE_ID = "zeffy-iframe";
export const EMBEDDED_BUTTON_LINK_ATTR = "zeffy-form-link";
export const EMBEDDED_FORM_SCRIPT = `<script src="${process.env.NEXT_PUBLIC_EMBEDDED_SCRIPT_URL}"></script>`;
